import { render, staticRenderFns } from "./v-3.vue?vue&type=template&id=3162776c&scoped=true&"
import script from "./v-3.vue?vue&type=script&lang=js&"
export * from "./v-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3162776c",
  null
  
)

export default component.exports